import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createCommentVNode as _createCommentVNode } from "vue"

import { onMounted, ref, watch } from "vue";
import debounce from "lodash/debounce";
import { useRouter } from "vue-router";
import FilterPhieuNhapXuat from "@/components/filter-phieu-nhap-xuat/FilterPhieuNhapXuat.vue";
import Pagination from "@/components/shared/pagination/Pagination.vue";
import { PHIEU_NHAP_KHO } from "@/core/constants/permissions";
import { PhieuNhapXuatStatusEnum } from "@/core/enums/phieuNhapXuatStatus.enum";
import { getErrorMsg, swalNotification } from "@/core/helpers/utils";
import { useAccount } from "@/core/hooks/use-account";
import { useLoading } from "@/core/hooks/use-loading";
import { usePagination } from "@/core/hooks/use-pagination";
import { usePageHeader } from "@/core/hooks/usePageHeader";
import {
  IKhoResponseBase,
  IPhieuNhapKhoResponseBase,
} from "@/core/interfaces/ApiResponses";
import { KhoService } from "@/core/services/Kho.service";
import { PhieuNhapKhoService } from "@/core/services/PhieuNhapKho.service";
import type {
  LoaiPhieu,
  PhieuNhapKhoListQuery,
  ProcessingStatus,
} from "@/types/phieu-nhap-kho";
import FilterItem from "@/layout/_shared/FilterItem.vue";
import PageContentBase from "@/layout/_shared/PageContentBase.vue";
import PageHeaderFilters from "@/layout/header/PageHeaderFilters.vue";
import PhieuNhapKhoTableV2 from "@/views/crafted/pages/phieu-nhap-kho/phieu-nhap-kho-table/PhieuNhapKhoTableV2.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'List',
  setup(__props) {

document.title = "Quản lý nhập kho - Đường sắt Hà Nội";

const router = useRouter();
const { currentUserData } = useAccount();
const { startLoading, endLoading } = useLoading();
const { currentPage, totalItems, perPage } = usePagination();

const items = ref<IPhieuNhapKhoResponseBase[]>([]);
const khoItems = ref<IKhoResponseBase[]>([]);
const selectedKhoId = ref<number | null>(null);
const loaiPhieuFilter = ref<LoaiPhieu | "">("");
const processStatusFilter = ref<ProcessingStatus | "">("");

const { searchQuery } = usePageHeader({
  title: "Quản lý nhập kho",
  breadcrumbs: [{ text: "Quản lý nhập kho" }],
  showSearch: true,
  searchPlaceholder: "Số phiếu, HĐ, hóa đơn, TK ...",
  addLabel: "Tạo mới",
  addPermissions: [PHIEU_NHAP_KHO.TAO_MOI],
  onAdd: () => router.push({ name: "tao-moi-quan-ly-nhap-kho" }),
});

const buildListQuery = (): PhieuNhapKhoListQuery => ({
  page: currentPage.value,
  ...(searchQuery.value?.trim() && { s: searchQuery.value.trim() }),
  ...(selectedKhoId.value != null && { id_kho: selectedKhoId.value }),
  ...(loaiPhieuFilter.value !== "" && {
    loai_phieu: loaiPhieuFilter.value as LoaiPhieu,
  }),
  ...(processStatusFilter.value !== "" && {
    processing_status: processStatusFilter.value as ProcessingStatus,
  }),
});

const fetchKhoItems = async () => {
  const {
    data: {
      data: { data },
    },
  } = await KhoService.fetchAllWarehousesByDepartmentId(
    currentUserData.value.departmentId
  );

  khoItems.value = data;
};

const fetchPhieuNhapKhoItems = async () => {
  try {
    startLoading();

    const {
      data: {
        data: { data, total },
      },
    } = await PhieuNhapKhoService.getList(buildListQuery(), perPage.value);

    items.value = data;
    totalItems.value = total;
    endLoading();
  } catch (e) {
    endLoading();
    await swalNotification(
      getErrorMsg(e, "Có lỗi xảy ra khi lấy danh sách phiếu nhập kho"),
      "error"
    );
  }
};

const onUpdateFilters = ({
  loaiPhieuFilter: nextLoai,
  processStatusFilter: nextStatus,
}: {
  loaiPhieuFilter: number | "";
  processStatusFilter: PhieuNhapXuatStatusEnum | "";
}) => {
  loaiPhieuFilter.value =
    nextLoai === "" ? "" : (nextLoai as LoaiPhieu);
  processStatusFilter.value =
    nextStatus === "" ? "" : (nextStatus as ProcessingStatus);
};

const resetOrFetch = () => {
  if (currentPage.value === 1) {
    fetchPhieuNhapKhoItems();

    return;
  }

  currentPage.value = 1;
};

watch(selectedKhoId, resetOrFetch);

watch(
  () => currentPage.value,
  () => {
    fetchPhieuNhapKhoItems();
  }
);

watch(
  () => perPage.value,
  resetOrFetch
);

watch([loaiPhieuFilter, processStatusFilter], resetOrFetch);

watch(
  searchQuery,
  debounce(() => {
    resetOrFetch();
  }, 300)
);

onMounted(async () => {
  try {
    startLoading();
    await fetchKhoItems();
    await fetchPhieuNhapKhoItems();
    endLoading();
  } catch (e) {
    endLoading();
    await swalNotification(
      getErrorMsg(e, "Có lỗi xảy ra khi tải dữ liệu"),
      "error"
    );
  }
});

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createBlock(PageContentBase, null, {
    default: _withCtx(() => [
      _createVNode(PageHeaderFilters, null, {
        default: _withCtx(() => [
          _createVNode(FilterItem, { label: "Kho" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: selectedKhoId.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedKhoId).value = $event)),
                class: "w-100",
                clearable: "",
                filterable: "",
                placeholder: "Tất cả kho"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(khoItems.value, (kho) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: kho.id,
                      label: kho.ten_kho,
                      value: kho.id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(FilterPhieuNhapXuat, {
            "loai-phieu": "nhap",
            onUpdateFilters: onUpdateFilters
          })
        ]),
        _: 1
      }),
      _createVNode(PhieuNhapKhoTableV2, {
        "cur-page": _unref(currentPage),
        items: items.value,
        "per-page": _unref(perPage),
        "show-edit-button": true,
        "show-kho-column": true,
        "show-xac-nhan-button": false,
        "show-phe-duyet-button": false,
        onRefresh: fetchPhieuNhapKhoItems
      }, null, 8, ["cur-page", "items", "per-page"]),
      (items.value.length > 0)
        ? (_openBlock(), _createBlock(Pagination, {
            key: 0,
            page: _unref(currentPage),
            "page-size": _unref(perPage),
            total: _unref(totalItems),
            onChangePage: _cache[1] || (_cache[1] = (value) => (currentPage.value = value)),
            onChangePageSize: _cache[2] || (_cache[2] = (value) => (perPage.value = value))
          }, null, 8, ["page", "page-size", "total"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})